export const baseUrl = process.env.NODE_ENV !== 'production' ? '/lexus/' :
    (window.location.origin + window.location.pathname).split('lexus_web')[0]